import { type RefObject, useRef } from "react";

// Use this hook to get a ref and focus function for an non-focusable element (eg: a div) that needs to be focused imperatively.
export const useFocusableElement = <T extends HTMLElement>(providedRef?: RefObject<T | null>) => {
  const internalRef = useRef<T>(null);
  const ref = providedRef ?? internalRef;

  const focus = (options: FocusOptions = { preventScroll: true }) => {
    ref.current?.focus(options);
  };

  return { ref, focus };
};
